import { FC, useEffect } from 'react';
import { useForm } from 'react-hook-form';

import { yupResolver } from '@hookform/resolvers/yup';
import { MonitoringItem } from '@services';
import { monitoringSchema } from '@constants';
import MainModal from './MainModal';
import { useMonitoring } from '../useMonitoring';

interface AddMonitoringModalProps {
  onClose: () => void;
  open: boolean;
  title: string;
  subtitle: string;
  editingItem?: Partial<MonitoringItem>;
}

export const AddMonitoringModal: FC<AddMonitoringModalProps> = ({
  onClose,
  open,
  title,
  subtitle,
  editingItem,
}) => {
  const {
    handleSubmit,
    control,
    reset,
    formState: { isValid },
  } = useForm<MonitoringItem>({
    resolver: yupResolver(monitoringSchema),
    defaultValues: editingItem,
    mode: 'onChange',
    delayError: 700,
  });

  const isEdit = !!editingItem;

  const { isCreating, isEditing, createMonitoring, editMonitoring } = useMonitoring();

  useEffect(() => {
    if (isEdit && editingItem) {
      reset(editingItem);
    } else {
      reset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editingItem, reset]);

  const handleCloseAndReset = () => {
    reset();
    onClose();
  };

  const onFinalSubmit = (data: MonitoringItem) => {
    if (data) {
      isEdit
        ? editMonitoring(data, {
            onSuccess: () => handleCloseAndReset(),
          })
        : createMonitoring(data, {
            onSuccess: () => handleCloseAndReset(),
          });
    }
  };

  return (
    <MainModal
      isEdit={isEdit}
      open={open}
      isValid={isValid}
      isLoading={isCreating || isEditing}
      control={control}
      handleSubmit={handleSubmit}
      onClose={handleCloseAndReset}
      onFinalSubmit={onFinalSubmit}
      title={title}
      subtitle={subtitle}
    />
  );
};
